export const ApplicationPaths = {
    Home: "/",
    SignIn: "login",
    SignOut: "logout",
};
